import React from 'react'
import { Button } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

type ModificationFormButtonsProps = {
  onCancel: () => void
  onPreview: () => void
  previewDisabled: boolean
}

export const ModificationFormButtons: React.FC<
  ModificationFormButtonsProps
> = ({ onCancel, onPreview, previewDisabled }) => {
  const { t } = useTranslation(['common'])

  return (
    <div className="mt-16 flex items-center justify-end">
      <Button type="button" variant="cancel" onClick={onCancel}>
        {t('common:cancel')}
      </Button>
      <Button
        type="button"
        variant="primary"
        onClick={onPreview}
        disabled={previewDisabled}
      >
        {t('common:preview')}
      </Button>
    </div>
  )
}
